"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_FamilyMemberHistory_Condition = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Age_1 = require("./RTTI_Age");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
exports.RTTI_FamilyMemberHistory_Condition = t.recursion('IFamilyMemberHistory_Condition', function () {
    return t.intersection([
        t.type({
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            outcome: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            contributedToDeath: t.boolean,
            _contributedToDeath: RTTI_Element_1.RTTI_Element,
            onsetAge: RTTI_Age_1.RTTI_Age,
            onsetRange: RTTI_Range_1.RTTI_Range,
            onsetPeriod: RTTI_Period_1.RTTI_Period,
            onsetString: t.string,
            _onsetString: RTTI_Element_1.RTTI_Element,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation)
        })
    ]);
});
//# sourceMappingURL=RTTI_FamilyMemberHistory_Condition.js.map